import gql from 'graphql-tag';

import { PhotoThumbnailsPhoto } from './photo';
import { UserDetails } from './account';

export const RosterIdentityLinkedIdentityAddressFields = gql`
  fragment RosterIdentityLinkedIdentityAddressFields on RosterIdentityLinkedIdentityAddress {
    id
    name
    address_line_1
    address_line_2
    city
    state
    post_code
    country {
      id
      name
    }
    soft_deleted
  }
`;

export const RosterIdentityLinkedIdentityDetails = gql`
  fragment RosterIdentityLinkedIdentityDetails on RosterIdentityLinkedIdentity {
    id
    account {
      id
      type
      ...UserDetails
    }
    phone_number
    addresses {
      records {
        ...RosterIdentityLinkedIdentityAddressFields
      }
    }
    identity {
      id
      name
      last_name
      has_outdated_selfie
      gender
      current_photo {
        id
        is_owner
        ...PhotoThumbnailsPhoto
      }
    }
  }

  ${PhotoThumbnailsPhoto}
  ${UserDetails}
  ${RosterIdentityLinkedIdentityAddressFields}
`;

export const RosterIdentityLinkDetails = gql`
  fragment RosterIdentityLinkDetails on RosterIdentityLinks {
    total
    records {
      id
      album {
        id
      }
      album_folder {
        id
      }
      grade
      class_name
      teacher_name
      department
      period
      track
      title
      ref_id
      cabin_name
      group_name
    }
  }
`;

export const AlbumFolderRosterIdentityLinkedIdentityDetails = gql`
  fragment AlbumFolderRosterIdentityLinkedIdentityDetails on RosterIdentityLinkedIdentity {
    id
    account {
      id
      type
      ...UserDetails
      transaction_items(
        album_folder_ids: [$id]
        include_album_folder_albums: true
      ) {
        total
      }
      broadcast_recipients_count(hierarchy_item_id: $id)
      last_broadcast_recipient(hierarchy_item_id: $id) {
        id
        created_at
      }
    }
    phone_number
    addresses {
      records {
        ...RosterIdentityLinkedIdentityAddressFields
      }
    }
    identity {
      id
      name
      last_name
      has_outdated_selfie
      matched_photo_notifications(slice: { limit: 1 }, album_folder_id: $id) {
        total
        records {
          id
          created_at
        }
      }
      current_photo {
        id
        is_owner
        ...PhotoThumbnailsPhoto
      }
      selected_identities(album_folder_id: $id, slice: { limit: 1 }) {
        records {
          id
          claimed
        }
      }
    }
  }

  ${PhotoThumbnailsPhoto}
  ${UserDetails}
  ${RosterIdentityLinkedIdentityAddressFields}
`;

export const RosterIdentityBaseDetails = gql`
  fragment RosterIdentityBaseDetails on RosterIdentity {
    id
    first_name
    last_name
    grade
    class_name
    teacher_name
    department
    title
    date_of_birth
    gender
    email_addresses {
      total
      records {
        id
        email_address
      }
    }
    selfie_photo {
      id
      is_owner
      ...PhotoThumbnailsPhoto
    }
    linked_identities(slice: { limit: 10 }) {
      total
      records {
        id
        ...RosterIdentityLinkedIdentityDetails
      }
    }
    photos {
      matched_photos {
        total
      }
    }
    photo_share_blocked
    organization_ref_id
    selfie_photo_filename
    selfie_photo_filenames {
      total
      records {
        id
        selfie_photo_filename
        selfie_photo {
          id
          ...PhotoThumbnailsPhoto
        }
      }
    }
    selfie_photo_urls {
      total
      records {
        id
        selfie_photo_url
        selfie_photo {
          id
          ...PhotoThumbnailsPhoto
        }
      }
    }
    links {
      ...RosterIdentityLinkDetails
    }
  }
  ${PhotoThumbnailsPhoto}
  ${RosterIdentityLinkedIdentityDetails}
  ${RosterIdentityLinkDetails}
`;
export const AlbumFolderRosterIdentityBaseDetails = gql`
  fragment AlbumFolderRosterIdentityBaseDetails on RosterIdentity {
    id
    first_name
    last_name
    date_of_birth
    grade
    class_name
    teacher_name
    gender
    email_addresses {
      total
      records {
        id
        email_address
      }
    }
    selfie_photo {
      id
      is_owner
      ...PhotoThumbnailsPhoto
    }
    linked_identities(slice: { limit: 10 }) {
      total
      records {
        id
        ...AlbumFolderRosterIdentityLinkedIdentityDetails
      }
    }
    photos {
      matched_photos {
        total
      }
    }
    photo_share_blocked
    organization_ref_id
    selfie_photo_filename
    selfie_photo_filenames {
      total
      records {
        id
        selfie_photo_filename
        selfie_photo {
          id
          ...PhotoThumbnailsPhoto
        }
      }
    }
    selfie_photo_urls {
      total
      records {
        id
        selfie_photo_url
        selfie_photo {
          id
          ...PhotoThumbnailsPhoto
        }
      }
    }
    links {
      ...RosterIdentityLinkDetails
    }
  }
  ${PhotoThumbnailsPhoto}
  ${AlbumFolderRosterIdentityLinkedIdentityDetails}
  ${RosterIdentityLinkDetails}
`;
